import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { usePlaylist, usePlaylistRemainingItemsAndProgress } from '../../savedItems';
import { usePlaylistIdFromSearch } from '../hooks';
import intersectionWith from 'hs-lodash/intersectionWith';
import { useMemo } from 'react'; // @ts-expect-error Untyped import

import ContentViewport from '../../../components/ContentViewport'; // @ts-expect-error Untyped import

import ContentControlWrapper from '../../../components/ContentControlWrapper';
import UIIllustration from 'UIComponents/image/UIIllustration';
import styled, { css, mediaQuery } from '../../../utils/Styling';
import H3 from 'UIComponents/elements/headings/H3';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import UIList from 'UIComponents/list/UIList';
import { RouterLink } from '../../../components/AcademyLinks';
import { getListingUrl } from '../../../utils/RoutingUtils';
import { useTrack } from '../../tracks';
import { useLesson } from '../../lessons';
import UIFlex from 'UIComponents/layout/UIFlex';
import { LearningContentContainer } from '../../learningContent';
const BASE_CLASS_NAME = 'exam-finished-screen';
const StyledUIIllustration = styled(UIIllustration).withConfig({
  displayName: "PlaylistIncompleteItems__StyledUIIllustration",
  componentId: "sc-1viq46s-0"
})(["margin-right:50px;margin-left:50px;", ""], mediaQuery('tablet', css(["display:none;"])));

const ContentLink = ({
  playlistItem
}) => {
  const {
    itemId,
    language,
    type,
    name
  } = playlistItem;
  const {
    track
  } = useTrack(itemId, language, type !== 'TRACK');
  const {
    lesson
  } = useLesson(itemId, language, type !== 'LESSON');
  if (!(track || lesson)) return null;
  return /*#__PURE__*/_jsx(RouterLink, {
    to: getListingUrl({
      type,
      id: itemId,
      language
    }),
    children: type === 'TRACK' ? track.name : lesson && lesson.name
  }, `${itemId}${type}${name}`);
};

export const PlaylistIncompleteItems = () => {
  const playlistId = usePlaylistIdFromSearch();
  const {
    remainingProgressItems
  } = usePlaylistRemainingItemsAndProgress(playlistId);
  const {
    playlist
  } = usePlaylist(playlistId);
  const incompleteItems = useMemo(() => {
    if (!remainingProgressItems || !playlist) return [];
    return intersectionWith(playlist.items, remainingProgressItems, (playlistItem, item) => {
      return item.itemId === playlistItem.itemId && item.type === playlistItem.type;
    });
  }, [playlist, remainingProgressItems]);
  return /*#__PURE__*/_jsxs(LearningContentContainer, {
    children: [/*#__PURE__*/_jsx(ContentViewport, {
      wrapperClassName: `${BASE_CLASS_NAME}__content-viewport`,
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        justify: "center",
        children: [/*#__PURE__*/_jsx(StyledUIIllustration, {
          name: "announcement"
        }), playlist && /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(H3, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.playlistContent.incompletePlaylistContent.incompleteTitle",
              options: {
                playlistTitle: playlist.name
              }
            })
          }), incompleteItems.length > 0 && /*#__PURE__*/_jsx(UIList, {
            children: incompleteItems.map(item => /*#__PURE__*/_jsx(ContentLink, {
              playlistItem: item
            }, `${item.itemId}${item.type}${item.name}`))
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(ContentControlWrapper, {
      className: `${BASE_CLASS_NAME}__content-control`
    })]
  });
};